import { useTranslation } from 'react-i18next';

import { FooterLink } from '../PublicLayout.StyledComponents';

interface LayoutFooterLinkProps {
  href: string;
  linkText: string;
  $invertColor?: boolean;
}

export const LayoutFooterLink: React.FC<LayoutFooterLinkProps> = ({
  href,
  linkText,
  $invertColor = true,
}) => {
  // get translations
  const { t } = useTranslation('common');

  return (
    <FooterLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      $invertColor={$invertColor}
    >
      {t(linkText)}
    </FooterLink>
  );
};
